import { OverflowTooltip } from '@/components';
import { OrganizationAvatar } from '@/components/OrganizationAvatar/OrganizationAvatar';
import { TableColumn, TableRow } from '@/components/Table/types';
import {
  automationsCountColumnConfig,
  businessAreasCountColumnConfig,
  companiesCountColumnConfig,
  deleteRowColumnConfig,
  processesCountColumnConfig,
  tasksCountColumnConfig,
} from '@/utils';
import { toggleStatusColumnConfig } from '@/utils/tableColumns/toggle-status-column-config';
import { Trans } from 'react-i18next';
import { OrganizationModel } from '../../domain';
type OrganizationsColumnsConfig = {
  onClick?: (row?: TableRow) => void;
  disableDeleteMessage?: string;
  onDeleteClick: (row?: TableRow) => void;
  onStatusChange: (checked: boolean, row: TableRow) => void;
};

export const getOrganizationsColumns = ({
  onClick,
  disableDeleteMessage,
  onDeleteClick,
  onStatusChange,
}: OrganizationsColumnsConfig): Array<TableColumn<OrganizationModel>> => {
  return [
    {
      id: 'name',
      label: <Trans i18nKey={'name'} />,
      acessorKey: 'name',
      sortable: true,
      align: 'left',
      alignHeader: 'left',
      className: 'max-w-[20vw] w-[20vw]',
      render: (_, row) => (
        <div
          className="flex items-center gap-2.5 overflow-hidden"
          onClick={() => onClick?.(row)}
        >
          <OrganizationAvatar
            organizationId={row.id}
            name={row.name}
            size="small"
            hasImage={!!row.profileImageFileId}
          />
          <OverflowTooltip text={row.name} textClassName="font-black" />
        </div>
      ),
    },
    toggleStatusColumnConfig({
      onChange: onStatusChange,
      parseValue: (value: string) => value === 'Active',
    }),
    {
      id: 'employees',
      acessorKey: 'usersCount',
      label: <Trans i18nKey={'employees'} />,
      sortable: true,
    },
    companiesCountColumnConfig(),
    businessAreasCountColumnConfig(),
    processesCountColumnConfig(),
    tasksCountColumnConfig(),
    automationsCountColumnConfig({
      options: {
        className: 'w-25',
      },
    }),
    deleteRowColumnConfig({
      disabledMessage: disableDeleteMessage,
      onDeleteClick: onDeleteClick,
    }),
  ];
};

export const getOrganizationsColumnsNamedMapped = (columnName: string) => {
  const organizationsColumnsNamedMapped: Record<string, string> = {
    id: 'Id',
    name: 'Name',
    description: 'Description',
    status: 'OrganizationStatus',
    usersCount: 'UsersCount',
    companiesCount: 'CompaniesCount',
    businessAreasCount: 'BusinessAreasCount',
    processesCount: 'ProcessesCount',
    tasksCount: 'TasksCount',
    workflowsCount: 'WorkflowsCount',
    automationsCount: 'AutomationsCount',
    timeSaved: 'TimeSaved',
    investmentReturn: 'InvestmentReturn',
  };

  return organizationsColumnsNamedMapped[columnName] ?? 'Name';
};
